<template>
  <div class="invoice-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Financeiro &raquo; Lista de {{ termPlural }}</span>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="d-flex align-items-center justify-content-end" >
<!--              <b-col cols="auto">-->
<!--                <router-link v-if="canAdd" tag="a" class="btn btn-primary btn-sm mr-2" :to="'/financeiro/'+url+'/'+newTerm"><i class="far fa-dot-circle"></i> Cadastrar {{ termSingular }}</router-link>-->
<!--              </b-col>-->
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <div class="mb-4">
          <b-row class="mb-2">
            <b-col cols="12" lg="6" xl="3">
              <label class="cj-label">Período</label>
              <date-range-picker
                  class="w-100"
                  ref="picker"
                  :localeData="dateRangePickerPtBrLocale"
                  :timePicker="false"
                  :timePicker24Hour="false"
                  :showDropdowns="true"
                  :ranges="false"
                  :showWeekNumbers="false"
                  :opens="'right'"
                  v-model="invoiceFilterForm.dateTime">
                <div slot="input" slot-scope="picker" class="">
                  {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{ moment(picker.endDate).format('DD/MM/YYYY') }}
                </div>
              </date-range-picker>
            </b-col>
            <b-col cols="12" lg="6" xl="3">
              <label class="cj-label">Unidade</label>
              <multiselect v-model="invoiceFilterForm.unit" :options="units" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="invoiceFilterForm.unit != null" @mousedown.prevent.stop="invoiceFilterForm.unit = null"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col cols="12" lg="6" xl="3">
              <label class="cj-label">Status</label>
              <multiselect v-model="invoiceFilterForm.status" :options="invoiceStatusOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="false" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="invoiceFilterForm.status != null" @mousedown.prevent.stop="invoiceFilterForm.status = null"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col cols="12" lg="6" xl="2">
              <label class="cj-label">ID da transação</label>
              <b-form-input type="text" v-model="invoiceFilterForm.zoopId"></b-form-input>
            </b-col>
            <b-col>
              <label class="cj-label w-100">&nbsp;</label>
              <b-button variant="primary" block @click="getInvoices(1)"><i class="far fa-search"></i></b-button>
            </b-col>
          </b-row>
        </div>

        <b-row class="header-info">
          <b-col cols="12">
            <div class="box-cj mb-2">
              <b-row class="mb-0">
                <b-col class="p-4 text-center d-flex flex-column align-items-center justify-content-center">
                    <p class="info mb-2">Total</p>
                    <p class="value active">R$ {{ formatPrice(statistics.reduce((total, item) => total + parseInt(item.value_in_cents), 0)/100.0) }}</p>
                </b-col>
                <b-col class="p-4 text-center d-flex flex-column align-items-center justify-content-center">
                  <p class="info mb-2">Ticket médio</p>
                  <p class="value active">R$ {{ formatPrice((statistics.reduce((total, item) => total + parseInt(item.value_in_cents), 0)/100.0)/Math.max(statistics.reduce((total, item) => total + parseInt(item.count), 0), 1)) }}</p>
                </b-col>
                <b-col class="p-4 text-center d-flex flex-column align-items-center justify-content-center">
                  <p class="info mb-2">N° de Transações</p>
                  <p class="value active">{{ statistics.reduce((total, item) => total + parseInt(item.count), 0) }}</p>
                </b-col>
                <b-col class="p-4 text-center">
                  <p class="info mb-2">Tipos de Pagamento</p>
                  <div>
                    <GChart v-if="invoicesByType.length > 1"
                        type="PieChart"
                        :data="invoicesByType"
                        :options="{ chartArea: { top: 8 }, legend: { alignment: 'center', position: 'bottom', textStyle: { color: '#212C3B', bold: true } }, is3D: false, height: 110 }" />
                    <p v-else class="value active">-</p>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Lista de {{ termPlural }}</p>
                  <p class="title"><small>{{ pagination.total }} {{ termPlural }} cadastrad{{ letter }}s</small></p>
                </div>
              </div>
              <div class="content">

                <table class="table table-responsive w-100 d-block d-md-table main-table-cj">
                  <thead>
                    <tr>
<!--                      <th>ID</th>-->
                      <th>Data</th>
                      <th>Descrição</th>
                      <th>Método de pagamento</th>
                      <th>Parcelas</th>
                      <th>Valor</th>
                      <th>Tarifa</th>
                      <th>Identificador</th>
                      <th>Status</th>
                      <th>Conta a receber</th>
                    </tr>
                  </thead>
                  <tbody>
                    <router-link tag="tr" :to="'/financeiro/'+url+'/'+invoice.id" v-for="invoice in invoices" :key="invoice.id">
<!--                      <td>{{ invoice.zoop_id }}</td>-->
                      <td>{{ moment(invoice.created_at).format('DD/MM/YYYY') }}</td>
                      <td>{{ invoice.appointment_id != null ? ('Agendamento ' + invoice.patient) : '-' }}</td>
                      <td>{{ invoice.payment_method == 'boleto' ? 'Boleto' : (invoice.payment_method == 'pix' ? 'Pix' : (invoice.card_brand + ' ' + invoice.card_bin + ' ****')) }}</td>
                      <td>{{ invoice.installments }}</td>
                      <td>R$ {{ formatPrice(invoice.value_in_cents/100.0) }}</td>
                      <td>{{ invoice.fees_in_cents != null ? ('R$ ' + formatPrice(invoice.fees_in_cents/100.0)) : '-' }}</td>
                      <td>{{ invoice.payment_method == 'boleto' ? invoice.boleto_document_number : (invoice.payment_method == 'Pix' ? invoice.pix_id : (invoice.card_nsu != null ? (invoice.card_nsu + '-' + invoice.card_auth) : '')) }}</td>
                      <td>{{ invoiceStatusOptions.find(g => g.value == invoice.status).name }}</td>
                      <td>{{ invoice.transaction_description != null ? invoice.transaction_description : '-' }}</td>
                    </router-link>
                  </tbody>
                </table>
                <p v-if="invoices.length == 0" class="text-center sub-title">A sua busca por {{ termSingular }} não encontrou nenhum resultado.</p>

                <div v-if="pagination.lastPage > 1">
                  <hr>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getInvoices"></b-pagination>
                </div>

              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        termSingular: 'transação',
        termPlural: 'transações',
        url: 'transacoes',
        letter: 'a',
        newTerm: 'cadastrar-transacao',
        module: 'units',

        pagination: {
          currentPage: 1,
          lastPage: 1,
          perPage: 20,
          total: 0
        },

        invoiceStatusOptions: [
          { value: 'new', name: 'Novo' },
          { value: 'pending', name: 'Pendente' },
          { value: 'pre_authorized', name: 'Pré-autorizado' },
          { value: 'succeeded', name: 'Pago' },
          { value: 'failed', name: 'Recusado' },
          { value: 'reversed', name: 'Revertido' },
          { value: 'canceled', name: 'Cancelado' },
          { value: 'refunded', name: 'Reembolsado' },
          { value: 'dispute', name: 'Em disputa' },
          { value: 'charged_back', name: 'Devolvido' }
        ],

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,

        invoices: [],
        statistics: [],
        invoicesByType: [],

        units: [],

        invoiceFilterForm: {
          dateTime: { startDate: this.moment().startOf('month'), endDate: this.moment().endOf('month') },
          status: null,
          unit: null,
          zoopId: ''
        },

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        }
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.canSee = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_remove');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      await this.api.getUnits({status: 'enabled', all: true}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.units = [];
        res.data.forEach(unit => {
          this.units.push({value: unit.id, name: unit.display_name});
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Units', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as unidades com meio de pagamento integrado da sua clínica! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Units', err.response);
      });

      this.getInvoices(this.pagination.currentPage);
    },
    methods: {
      getInvoices(page) {
        let invoiceFilterData = {
          start_date: this.moment(this.invoiceFilterForm.dateTime.startDate).format('YYYY-MM-DD'),
          end_date: this.moment(this.invoiceFilterForm.dateTime.endDate).format('YYYY-MM-DD'),
          zoop_id: this.invoiceFilterForm.zoopId,
          status: (this.invoiceFilterForm.status != null)?this.invoiceFilterForm.status.value:null,
          unit_id: (this.invoiceFilterForm.unit != null)?this.invoiceFilterForm.unit.value:null,
          page: page
        };

        this.api.getInvoices(invoiceFilterData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.invoices = res.data.invoices.data;

          this.pagination.currentPage = res.data.invoices.current_page;
          this.pagination.lastPage = res.data.invoices.last_page;
          this.pagination.total = res.data.invoices.total;

          this.statistics = res.data.statistics;
          this.invoicesByType = [['Tipo', 'Total']];
          this.statistics.forEach(statistics => {
            this.invoicesByType.push([this.getPaymentMethodName(statistics.payment_method), statistics.value_in_cents/100.0])
          });

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Invoices', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar as transações da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Invoices', err.response);
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      getPaymentMethodName(paymentMethod) {
        if(paymentMethod == 'credit') {
          return 'Cartão de Crédito';
        }
        if(paymentMethod == 'debit') {
          return 'Cartão de Débito';
        }
        if(paymentMethod == 'boleto') {
          return 'Boleto';
        }
        if(paymentMethod == 'boleto') {
          return 'Boleto';
        }
        return 'pix';
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .invoice-list {
    padding: 20px 0;

    .header-info {
      p {
        margin: 0;
      }

      .info {

      }

      .value {
        font-size: 28px;
        color: $linkWater;

        &.active {
          color: $curiousBlue;
        }
      }
    }

    .box-cj {
      .content {
        th {
          color: $cadetGray;
          border-top: 0;
        }

        tbody {
          color: $waikawaGray;

          tr:nth-child(even) {
            background-color: $whisper;
          }

          tr:nth-child(odd) {
          }

          td {
            font-size: 14px;
          }
        }
      }
    }
  }
</style>
